export default "__VITE_ASSET__B847aADH__"